"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_URL = void 0;
exports.REGEXP_URL = /((https?:\/\/)|(www\.))[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,7}\b([-a-zA-Z0-9@:%_+.~#?&//=,;]*)/gi;
